import { render } from "./mainLayout.component.vue?vue&type=template&id=cf71fd76&scoped=true&ts=true"
import script from "./mainLayout.component.vue?vue&type=script&lang=ts"
export * from "./mainLayout.component.vue?vue&type=script&lang=ts"

import "./mainLayout.component.vue?vue&type=style&index=0&id=cf71fd76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf71fd76"]])

export default __exports__